module.exports = __webpack_public_path__ + "img/undefined.ac7fa04d.svg";